/* import __COLOCATED_TEMPLATE__ from './file-question.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './file-question.module.scss';

export default class RequestPrescreenerQuestionTypesFileQuestion extends Component {
  @service prescreener;
  @service media;

  styles = styles;

  get isDesktopFeatureEnabled() {
    return !this.media.isXsDown;
  }

  get primaryInstructions() {
    return this.isDesktopFeatureEnabled ? 'Choose file' : 'Upload a file';
  }

  get secondaryInstructions() {
    return this.isDesktopFeatureEnabled ? ' or drag and drop file' : ' or take a picture';
  }

  @action
  onFileUploadFront(file) {
    this.prescreener.insuranceCardFront = file;
    this.sendOnChange(file.name);
  }

  @action
  onFileUploadBack(file) {
    this.prescreener.insuranceCardBack = file;
    this.sendOnChange(file.name);
  }

  sendOnChange(fileName) {
    this.args.onChange?.(this.args.question, !!fileName);
  }
}
